export default `
<div class="content" id="popup_content_mode_update_help_2019" style="text-align:center;">
<div class="popup_flashing"></div>
<p data-translate="popupUpdateModeInstructions2019Body" class="center"></p>
</div>
`;
